import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")

import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import Datatable from "@/components/kt-datatable/Datatable3.vue";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  props: {
  filters: { type: Object, required: true },
  apiUrl: { type: String, required: true },
  title: { type: String, required: true },
  reportId: { type: Number, required: true },
  exportToExcel: { type: Boolean, default: false },
  loading: {type: Boolean, default: false},  // 父组件控制子组件的载入
},
  emits: ['tableData', 'tableField'],
  setup(__props, { emit }) {

const props = __props




const store = useStore();
const dataT = ref<HTMLElement | null>(null);
const tableHeader = ref<Array<any>>([]);
const filters = reactive(props.filters as Object);
const defaultSort = ref('');

onMounted(() => {
  filters['report_id'] = props.reportId;
});

watch(props, (val) => {
  if (props.loading) (dataT as any).value.setCurrent(1);
});

const loadHeader = (func) => {
  ApiService.get('report/product/indicator', {report_id: props.reportId}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      let th: Array<any> = [];
      let fields: Array<any> = [];
      for (let d of data) {
        let t = {
          name: d.name,
          key: d.field,
          desc: d.description,
          data_type: d.data_type,
        }
        if (d.field === 'weekly'){
          t['width'] = 155;
          t['fixed'] = true;
        }
        if (d.field === 'gmv') t['width'] = 80;
        if (d.field === 'imp_pv') t['width'] = 65;
        th.push(t);
        if (d.is_display) fields.push(d);
      }
      tableHeader.value = [...th];
      emit('tableField', fields);
    }
  });
}

const tableData = (data) => {
  emit('tableData', data);
}

// 导出
const toExcel = () => {
  let fields: Array<any> = [], field_names: Array<any> = [];
  for(let v of tableHeader.value) {
    fields.push(v.key);
    field_names.push(v.name);
  }
  (dataT as any).value.toExcel(fields, props.title, field_names)
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: props.apiUrl,
    "table-header": tableHeader.value,
    "default-sort": defaultSort.value,
    "enable-items-per-page-dropdown": false,
    filters: _unref(filters),
    actionMenu: false,
    preLoad: loadHeader,
    onTableData: tableData
  }, {
    search: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.title), 1)
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-document",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toExcel()))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["apiUrl", "table-header", "default-sort", "filters"])), [
    [_directive_loading, props.loading]
  ])
}
}

})